import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';

const CoreTeam = () => {
  // Placeholder data - replace with actual data from API
  const coreMembers = [
    {
      id: 1,
      name: 'Member Name 1',
      role: 'President',
      description: 'Leading the foundation with vision and dedication',
      image: null,
    },
    {
      id: 2,
      name: 'Member Name 2',
      role: 'Secretary',
      description: 'Managing operations and coordination',
      image: null,
    },
    {
      id: 3,
      name: 'Member Name 3',
      role: 'Treasurer',
      description: 'Overseeing financial transparency and accountability',
      image: null,
    },
  ];

  const advisoryBoard = [
    {
      id: 1,
      name: 'Advisor Name 1',
      expertise: 'Education & Mentorship',
      description: 'Expert in educational initiatives',
      image: null,
    },
    {
      id: 2,
      name: 'Advisor Name 2',
      expertise: 'Women Empowerment',
      description: 'Specialist in women empowerment programs',
      image: null,
    },
  ];

  const officeBearers = [
    { role: 'President', name: 'Member Name 1' },
    { role: 'Vice President', name: 'Member Name 2' },
    { role: 'Secretary', name: 'Member Name 3' },
    { role: 'Joint Secretary', name: 'Member Name 4' },
    { role: 'Treasurer', name: 'Member Name 5' },
  ];

  return (
    <Box sx={{ minHeight: '80vh', py: 8, backgroundColor: '#ffffff' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          component="h1"
          sx={{
            textAlign: 'center',
            fontWeight: 700,
            mb: 2,
            color: '#f97316',
          }}
        >
          Core Team & Governance
        </Typography>
        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            color: 'text.secondary',
            mb: 6,
            maxWidth: '800px',
            mx: 'auto',
          }}
        >
          Meet the dedicated team leading GBCN Foundation towards positive social impact
        </Typography>

        {/* Core Members */}
        <Box sx={{ mb: 8 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
            <GroupsIcon sx={{ fontSize: 40, color: '#f97316', mr: 2 }} />
            <Typography variant="h4" sx={{ fontWeight: 600, color: '#111827' }}>
              Core Members
            </Typography>
          </Box>
          <Grid container spacing={4}>
            {coreMembers.map((member) => (
              <Grid item xs={12} sm={6} md={4} key={member.id}>
                <Card
                  sx={{
                    height: '100%',
                    border: '1px solid #e5e7eb',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: '0 8px 24px rgba(249, 115, 22, 0.15)',
                    },
                  }}
                >
                  <CardContent sx={{ textAlign: 'center', p: 3 }}>
                    <Avatar
                      sx={{
                        width: 120,
                        height: 120,
                        mx: 'auto',
                        mb: 2,
                        bgcolor: '#f97316',
                        fontSize: '3rem',
                      }}
                    >
                      {member.image ? (
                        <Box component="img" src={member.image} alt={member.name} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <PersonIcon sx={{ fontSize: 60 }} />
                      )}
                    </Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: '#111827' }}>
                      {member.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#f97316', mb: 2, fontWeight: 600 }}>
                      {member.role}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {member.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Advisory Board */}
        <Box sx={{ mb: 8 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
            <BusinessIcon sx={{ fontSize: 40, color: '#f97316', mr: 2 }} />
            <Typography variant="h4" sx={{ fontWeight: 600, color: '#111827' }}>
              Advisory Board
            </Typography>
          </Box>
          <Grid container spacing={4}>
            {advisoryBoard.map((advisor) => (
              <Grid item xs={12} md={6} key={advisor.id}>
                <Card
                  sx={{
                    height: '100%',
                    border: '1px solid #e5e7eb',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: '0 8px 24px rgba(249, 115, 22, 0.15)',
                    },
                  }}
                >
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Avatar
                        sx={{
                          width: 80,
                          height: 80,
                          mr: 2,
                          bgcolor: '#f97316',
                        }}
                      >
                        {advisor.image ? (
                          <Box component="img" src={advisor.image} alt={advisor.name} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <PersonIcon sx={{ fontSize: 40 }} />
                        )}
                      </Avatar>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#111827' }}>
                          {advisor.name}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#f97316', fontWeight: 600 }}>
                          {advisor.expertise}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                      {advisor.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Office Bearers */}
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 600, mb: 4, color: '#111827' }}>
            Office Bearers
          </Typography>
          <Card sx={{ border: '1px solid #e5e7eb' }}>
            <CardContent>
              <Grid container spacing={2}>
                {officeBearers.map((bearer, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Box sx={{ p: 2, border: '1px solid #e5e7eb', borderRadius: 2 }}>
                      <Typography variant="body2" sx={{ color: '#f97316', fontWeight: 600, mb: 1 }}>
                        {bearer.role}
                      </Typography>
                      <Typography variant="body1" sx={{ color: '#111827', fontWeight: 500 }}>
                        {bearer.name}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Box>
  );
};

export default CoreTeam;

